import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { useInvalidateTimeBlocks } from '@/api/reservations/get-time-blocks'
import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'
import { toastFactory } from '@/factories'
import { deleteTimeBlock } from '@/reducers/Organisation/reservationsReducer'

interface DeleteTimeBlockConfirmationPopupProps {
  timeBlockId: number
  onClose: VoidFunction
  onConfirm?: VoidFunction
}

export const DeleteTimeBlockConfirmationPopup = ({
  timeBlockId,
  onClose,
  onConfirm,
}: DeleteTimeBlockConfirmationPopupProps) => {
  const { t } = useTranslation(['reservations', 'common'])
  const dispatch = useDispatch() as any
  const invalidateTimeBlocks = useInvalidateTimeBlocks()

  const handleConfirm = async () => {
    try {
      await dispatch(deleteTimeBlock(timeBlockId))
      invalidateTimeBlocks()
      toastFactory.success(t('reservations:timeBlocks.deleteModal.toasts.success'))
      onConfirm?.()
    } catch {
      toastFactory.error(t('reservations:timeBlocks.deleteModal.toasts.error'))
    }
  }

  return (
    <ConfirmationPopup
      title={t('reservations:shared.confirmationTitle')}
      cancelText={t('common:actions.cancel')}
      confirmText={t('reservations:timeBlocks.deleteModal.confirm')}
      variant="danger"
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <Typography>{t('reservations:timeBlocks.deleteModal.body')}</Typography>
    </ConfirmationPopup>
  )
}
